/* unplugin-vue-components disabled */import script from "./CookiesBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookiesBanner.vue?vue&type=script&lang=ts&setup=true"

import "./CookiesBanner.vue?vue&type=style&index=0&id=7b8ea2a9&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8ea2a9"]])

export default __exports__